import { render, staticRenderFns } from "./PPVNormativeCharts.vue?vue&type=template&id=a5fcb870&scoped=true&"
import script from "./PPVNormativeCharts.vue?vue&type=script&lang=js&"
export * from "./PPVNormativeCharts.vue?vue&type=script&lang=js&"
import style0 from "./PPVNormativeCharts.vue?vue&type=style&index=0&id=a5fcb870&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5fcb870",
  null
  
)

/* custom blocks */
import block0 from "./PPVNormativeCharts.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports